import { z } from 'zod';

export const TenantIdSchema = z.string().uuid();
export type TenantId = z.infer<typeof TenantIdSchema>;

export const TimestampSchema = z.string().datetime();
export type Timestamp = z.infer<typeof TimestampSchema>;

/**
 * Pénzösszeg HUF-ban — **plain `number`** (NEM `{amount,currency}` objektum).
 *
 * Backend-igazítás (ADR-133-align, Javo: B): a teljes backend (`Create*Dto` + ~636
 * végpont) + a Prisma `Decimal(12,2)` mind **`number`** (Ft)-et használ. A korábbi
 * `{amount,currency}` objektum-alak frontend↔élő-API money-shape mismatch-et adott
 * (product/equipment/rental/package mind). Single-currency (HUF), így a `currency`
 * mező redundáns volt. `Decimal(12,2)` → 2 tizedes megengedett, ezért NINCS `.int()`.
 *
 * **Signed** (NEM `.nonnegative()`, Javo measured-verify): a backend tele van
 * signed-money mezővel — `currentBalance` (tartozás/túlfizetés), `variance`/
 * `varianceValue` (hiány = negatív), `StockAdjustment`/`closingBalance−expected`
 * (korrekció/sztornó/jóváírás). A `Decimal(12,2)` maga signed; a ≥0 megkötés
 * **field-szintű** (`.nonnegative()` az adott price-mezőn), NEM a shared típuson —
 * különben latens footgun. A type-shape a contracté, a value-validáció a backendé.
 */
export const MoneyHufSchema = z.number();
export type MoneyHuf = z.infer<typeof MoneyHufSchema>;

export const AuditFieldsSchema = z.object({
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
  createdBy: z.string().uuid().nullable(),
  updatedBy: z.string().uuid().nullable(),
});
export type AuditFields = z.infer<typeof AuditFieldsSchema>;

export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.unknown()).optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;
